import React, {createContext, useCallback, useContext, useEffect, useState} from 'react';
import moment from 'moment';

const TimeRangeContext = createContext();

const RANGE_LABELS = {
  "1h": "Last hour",
  "1d": "Today",
  "7d": "This Week",
  "30d": "This Month",
};

export const TimeRangeProvider = ({children}) => {
  const [range, setRange] = useState('1h');
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  const updateRelativeRange = useCallback((relativeValue = "1h") => {
    const now = new Date();
    let hours = 24;

    switch (relativeValue) {
      case "1h":
        hours = 1;
        break;
      case "1d":
        hours = 24;
        break;
      case "7d":
        hours = 7 * 24;
        break;
      case "30d":
        hours = 30 * 24;
        break;
      default:
        hours = 1;
        relativeValue = "1h";
        break;
    }

    const startDate = new Date(now.getTime() - (hours * 60 * 60 * 1000));
    setStart(startDate.toISOString());
    setEnd(now.toISOString());
    setRange(relativeValue);
  }, []);

  const updateAbsoluteRange = useCallback((startIso, endIso) => {
    setStart(startIso);
    setEnd(endIso);
    setRange(`${moment(startIso).format('DD.MM.YYYY HH:mm')} - ${moment(endIso).format('DD.MM.YYYY HH:mm')}`);
  }, []);

  useEffect(() => {
    updateRelativeRange('1h');
  }, [updateRelativeRange]);

  return (
    <TimeRangeContext.Provider
      value={{
        range,
        rangeLabels: RANGE_LABELS,
        start,
        end,
        updateRelativeRange,
        updateAbsoluteRange,
      }}
    >
      {children}
    </TimeRangeContext.Provider>
  );
};

export const useTimeRange = () => {
  const context = useContext(TimeRangeContext);
  if (!context) {
    throw new Error('useTimeRange must be used within TimeRangeProvider');
  }
  return context;
};

